import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { closePopover } from '../../actions/popover'
import PopoverLayout from './popover_layout'
import { fetchManagedBusinesses } from '../../actions/businesses'
import Button from '../button'
import Text from '../text'
import Image from '../image'

class ManagedBusinessesPopover extends React.PureComponent {

  componentDidMount() {
    this.props.onFetchManagedBusinesses()
  }

  handleOnClosePopover = () => {
    this.props.onClosePopover()
  }

  handleOnClick = (businessId) => {
    const { onClick } = this.props
    !!onClick && onClick(businessId)
    this.handleOnClosePopover()
  }

  render() {
    const { isXS, managedBusinesses } = this.props

    return (
      <PopoverLayout
        width={320}
        isXS={isXS}
        onClose={this.handleOnClosePopover}
      >
        {
          managedBusinesses && managedBusinesses.map((business) => {
            return (
              <Button
                noClasses
                className={[_s.d, _s.bgPrimary, _s.mt10, _s.flexRow, _s.cursorPointer, _s.border1PX, _s.borderColorSecondary, _s.boxShadowBlock, _s.noUnderline, _s.bgSubtle_onHover, _s.radiusSmall, _s.px5, _s.py10].join(' ')}
                onClick={() => this.handleOnClick(business.get('id'))}
              >
                <div className={[_s.d, _s.radiusTiny, _s.borderColorPrimary].join(' ')}>
                  <Image
                    src={business.get('logo_thumbnail_url')}
                    width={40}
                    height={40}
                    className={[_s.radiusTiny].join(' ')}
                  />
                </div>
                <div className={[_s.d, _s.ml10].join(' ')}>
                  <Text size='medium' weight='medium'>{business.get('name')}</Text>
                  <Text color='secondary' className={[_s.capitalize, _s.mt5].join(' ')}>{business.get('status')}</Text>
                </div>
              </Button>
            )
          })
        }
      </PopoverLayout>
    )
  }

}

const mapStateToProps = (state) => {
  const managedBusinessIds = state.getIn(['business_lists', 'managed', 'items'])
  const managedBusinesses = !!managedBusinessIds ? managedBusinessIds.map((bizId) => {
    return state.getIn(['businesses', 'items', bizId])
  }) : null

  return {
    managedBusinesses,
  }
}

const mapDispatchToProps = (dispatch) => ({
  onClosePopover:() => dispatch(closePopover()),
  onFetchManagedBusinesses() {
    dispatch(fetchManagedBusinesses())
  },
})

ManagedBusinessesPopover.defaultProps = {
  tab: PropTypes.string.isRequired,
  onClosePopover: PropTypes.func.isRequired,
}

export default connect(mapStateToProps, mapDispatchToProps)(ManagedBusinessesPopover)